export const POSTURL = process.env.PUBLIC_URL;
export const APIURL = "https://codebotapi.mobileprogramming.com/";
